import ModelService from './ModelService';
const modelService = new ModelService();

const model = 'user-activities';

export async function GetUserActivities(fromDate = null) {
  const params = fromDate ? `?from_date=${fromDate}` : '';
  return modelService.IndexModel(`${model}/export${params}`);
}
